module.exports = __webpack_public_path__ + "fa-solid-900.woff?d745348d289b149026921f197929a893";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/webfonts/fa-solid-900.woff
// module id = 1457
// module chunks = 0